import React, { useEffect, useState } from "react";
import "./screen-tip.scss";

const Loading = () => {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [host,setHost] = useState(window.location.host);
  const [isSkip, setIsSkip] = useState(false);
  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
    };

    // 监听屏幕旋转
    window?.addEventListener("resize", handleOrientationChange);
    window?.addEventListener("orientationchange", handleOrientationChange);

    // 清除事件监听器
    return () => {
      window?.removeEventListener("resize", handleOrientationChange);
      window?.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  let skipCount = Number(sessionStorage.getItem("skip-count")) || 0;
  const handleDoubleClick = () => {
    console.log("?????", skipCount)
    skipCount++;
    sessionStorage.setItem("skip-count", skipCount.toString());
    if (skipCount >= 3) {
      setIsSkip(true);
      sessionStorage.setItem("skip-count", "0");
    }
  };

  return (
    <>
      {!isSkip && (
        <div className="screen-tip-container">
          {/*  onClick={handleDoubleClick} */}
          <div className="mobile-tip">
            {/* <img
              className="tip-icon"
              src="data:image/svg+xml;base64,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"
              alt=""
            /> */}
            <div className="tip-text">为了您更好的体验</div>
            <div className="tip-text">
              请使用电脑访问
            </div>
            <div className="tip-text">
              {host}
            </div>
            {/* <div className="tip-text">Please unlock the screen rotation</div>
            <div className="tip-text">
              And rotate to {isPortrait ? "horizontal" : "vertical"} screen
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
